import mark from './mark.png';
import steven from './steven.png';

export default {
  mark,
  steven,
};
